import React from 'react';
import {Select} from 'antd';
const Option = Select.Option;

 const BusinessOverviewYearDropdown = (props) => {

  const businessOverviewYearChange = (value) => {
    props.businessOverviewYearChange(value);
  };

  return (
    <Select size="large" style={{ width: 300, 'marginLeft': 20 }}
      className="overview year"
      value={props.year}
      onChange={value => businessOverviewYearChange(value)}
      >
      {
        props.years.length === 0 ? 
        (<Option value="Year">Year</Option>) : 
        ( props.years.map((item, index) => {
          return <Option key={index} value={item.year}>{item.year}</Option>
        }))
      }
    </Select>
  )
  
}
export default BusinessOverviewYearDropdown



// WEBPACK FOOTER //
// ./src/components/economicProfile/BusinessOverviewYearDropdown.js